export enum Entity {
  Encounter = 'ENCOUNTER',
  Patient = 'PATIENT',
  Order = 'ORDER',
  ExternalDocumentPacket = 'EXTERNAL_DOCUMENT_PACKET',
}

export interface Result {
  id: string;
  entity: {
    name: string;
    type: Entity;
  };
  tags: string[];
  organization: string;
  practiceId?: string;
  /** IDs of older equivalent EhrInformation records deduplicated out of the result. Excludes the primary `id`. Only present for Patient results with more than one equivalent record. */
  equivalentEntityIds?: string[];
}

export interface SearchQueryParams {
  q: string;
  entityType?: Entity;
  organizationId?: string;
  fuzzySearch?: boolean;
}

export enum SearchMode {
  TestOnly = 'TestOnly',
  AllData = 'AllData',
}
